module.exports =  {
    // HQ - 앱 통계
    seriesAppConnect: [
        { name: "접속 수", field: "connectUser", stack: "base", option: { itemStyle: { color: "#016FC0" } } },
    ],
    seriesAppNewUser: [
        { name: "실행 수", field: "newUser", stack: "base", type: "line", option: { smooth: false, itemStyle: { color: "#016FC0" } } },
    ],
    seriesAge: [
        { name: "만3세", ageStat: 3, ageDB: 1, field: "playCountSum3", stack: "base3", option: { itemStyle: { color: "#FDC60D" } } },
        { name: "만4세", ageStat: 4, ageDB: 2, field: "playCountSum4", stack: "base4", option: { itemStyle: { color: "#FF8181" } } },
        { name: "만5세", ageStat: 5, ageDB: 3, field: "playCountSum5", stack: "base5", option: { itemStyle: { color: "#91D051" } } },
        { name: "혼합", ageStat: 345, ageDB: 123, field: "playCountSum345", stack: "base345", option: { itemStyle: { color: "#A568D2" } } },
    ],
    seriesAppVersion: [
        { name: "사용 수", field: "playCountSum", stack: "base", option: { itemStyle: { color: "#FEC100" } } },
    ],
    seriesAppContent: [
        { name: "순 실행 수", field: "playCount", stack: "base", option: { itemStyle: { color: "#FF999A" } } },
        { name: "누적 실행 수", field: "playCountSum", stack: "base", option: { itemStyle: { color: "#EC7D32" } } },
    ],
    seriesAppMenu: [
        { name: "사용량", field: "playCountSum", stack: "base", option: { itemStyle: { color: "#9999FF" } } },
    ],
    // HQ - 지사 통계
    seriesBranchPlayCount: [
        { name: "순 실행 수", field: "playCount", stack: "base", option: { itemStyle: { color: "#FF999A" } } },
        { name: "누적 실행 수", field: "playCountSum", stack: "base", option: { itemStyle: { color: "#EC7D32" } } },
    ],
    // HQ - 원 통계
    seriesNurseryPlayCountBar: [
        { name: "순 실행 수", field: "playCount", stack: "base1", type: "bar", option: { itemStyle: { color: "#FF999A" } } },
        { name: "누적 실행 수", field: "playCountSum", stack: "base2", type: "bar", option: { itemStyle: { color: "#EC7D32" } } },
    ],
    seriesNurseryPlayCount: [
        { name: "순 실행 수", field: "playCount", stack: "base1", type: "line", option: { smooth: false, itemStyle: { color: "#FF999A" } } },
        { name: "누적 실행 수", field: "playCountSum", stack: "base2", type: "line", option: { smooth: false, itemStyle: { color: "#EC7D32" } } },
    ],
    seriesNurseryAge: [
        { name: "순 실행 수", field: "playCount", stack: "base", option: { itemStyle: { color: "#FA8888" } } },
        { name: "누적 실행 수", field: "playCountSum", stack: "base", option: { itemStyle: { color: "#E88442" } } },
    ],
    seriesNurseryMenu: [
        { name: "사용량", field: "playCountSum", stack: "base", option: { itemStyle: { color: "#9999FF" } } },
    ],
    // Branch - 원 통계
    seriesBranchNurseryPlayCount: [
        { name: "사용량", field: "playCountSum", stack: "base", type: "line", option: { smooth: false, itemStyle: { color: "#2477C1" } } },
    ],
    seriesBranchNurseryClassPlayCount: [
        { name: "사용량", field: "playCountSum", stack: "base", type: "bar", option: { itemStyle: { color: "#E88442" } } },
    ],
    tableBranchClassUse: {
        header: "#F8CBAD",
        columnFirst: "#FFE699"
    },
    // Branch - 반 통계
    seriesBranchClassPlayCount: [
        { name: "사용량", field: "playCountSum", stack: "base", type: "line", option: { smooth: false, itemStyle: { color: "#2477C1" } } },
    ],
    seriesBranchClassMenuPlayCount: [
        { name: "사용량", field: "playCountSum", stack: "base", type: "bar", option: { itemStyle: { color: "#FEC100" } } },
    ],
};